<template>
  <div>
    <v-layout wrap>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('fullName') }"
      >
        <span>{{ $t('full_name') }} </span><span class="red--text">*</span>
        <v-text-field
          v-model="input.full_name"
          v-validate="'required'"
          flat
          outline
          solo
          :placeholder="$t('full_name')"
          name="fullName"
          class="default-input-textfield"
          :data-vv-as="$t('full_name')"
          hide-details
        ></v-text-field>
        <p v-if="errors.has('fullName')" class="text-error pt-2">
          {{ errors.first('fullName') }}
        </p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('customerType') }"
      >
        <span>{{ $t('customer_type') }} </span><span class="red--text">*</span>
        <v-select
          v-model="input.customer_type"
          v-validate="'required'"
          flat
          outline
          full-width
          :items="['ลูกค้าเก่า', 'ลูกค้าใหม่']"
          solo
          name="customerType"
          :placeholder="$t('customer_type')"
          :data-vv-as="$t('customer_type')"
          class="default-input-textfield"
          hide-details
        ></v-select>
        <p v-if="errors.has('customerType')" class="text-error pt-2">
          {{ errors.first('customerType') }}
        </p>
      </v-flex>
      <v-flex xs6 sm4 class="form-control px-2 pb-3" :class="{ 'has-error': errors.has('email') }">
        <span>{{ $t('email') }} </span>
        <v-text-field
          v-model="input.email"
          flat
          outline
          solo
          :placeholder="$t('email')"
          name="email"
          class="default-input-textfield"
          :data-vv-as="$t('email')"
          hide-details
        ></v-text-field>
        <p v-if="errors.has('email')" class="text-error pt-2">{{ errors.first('email') }}</p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('phoneNumber') }"
      >
        <span>{{ $t('phone_number') }} </span><span class="red--text">*</span>
        <v-text-field
          v-model="input.phone_number"
          v-validate="'required|isUserPhone'"
          flat
          outline
          max="10"
          solo
          type="number"
          :placeholder="$t('phone_number')"
          name="phoneNumber"
          class="default-input-textfield"
          :data-vv-as="$t('phone_number')"
          hide-details
        ></v-text-field>
        <p v-if="errors.has('phoneNumber')" class="text-error pt-2">
          {{ errors.first('phoneNumber') }}
        </p>
      </v-flex>
      <v-flex xs6 sm4 class="form-control px-2 pb-3" :class="{ 'has-error': errors.has('branch') }">
        <span>{{ $t('branch') }} </span><span class="red--text">*</span>
        <v-select
          v-model="input.branch_id"
          v-validate="'required'"
          flat
          outline
          full-width
          :items="branchOptions"
          solo
          name="branch"
          :placeholder="$t('branch')"
          :data-vv-as="$t('branch')"
          class="default-input-textfield"
          item-text="name"
          item-value="id"
          hide-details
        ></v-select>
        <p v-if="errors.has('branch')" class="text-error pt-2">
          {{ errors.first('branch') }}
        </p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('pledgeWaterTank') }"
      >
        <span>{{ $t('pledge_water_tank') }} </span><span class="red--text">*</span>
        <v-select
          v-model="input.pledge_water_tank"
          v-validate="'required'"
          flat
          outline
          full-width
          :items="pledgeWaterTankOptions"
          :item-text="'label'"
          :item-value="'value'"
          solo
          name="pledgeWaterTank"
          :placeholder="$t('pledge_water_tank')"
          :data-vv-as="$t('pledge_water_tank')"
          class="default-input-textfield"
          hide-details
        ></v-select>

        <p v-if="errors.has('pledgeWaterTank')" class="text-error pt-2">
          {{ errors.first('pledgeWaterTank') }}
        </p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('totalPledgeWaterTank') }"
      >
        <span>{{ $t('total_pledge_water_tank') }} </span><span class="red--text">*</span>
        <v-text-field
          v-model="input.total_pledge_water_tank"
          v-validate="'required'"
          flat
          outline
          solo
          :placeholder="$t('total_pledge_water_tank')"
          name="totalPledgeWaterTank"
          class="default-input-textfield"
          :data-vv-as="$t('total_pledge_water_tank')"
          hide-details
        ></v-text-field>
        <p v-if="errors.has('totalPledgeWaterTank')" class="text-error pt-2">
          {{ errors.first('totalPledgeWaterTank') }}
        </p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('addressLat') }"
      >
        <span>{{ $t('latitude') }} </span>
        <v-text-field
          v-model="input.address_lat"
          flat
          outline
          solo
          :placeholder="$t('latitude')"
          name="addressLat"
          class="default-input-textfield"
          :data-vv-as="$t('latitude')"
          hide-details
          disabled
        ></v-text-field>
        <p v-if="errors.has('addressLat')" class="text-error pt-2">
          {{ errors.first('addressLat') }}
        </p>
      </v-flex>
      <v-flex
        xs6
        sm4
        class="form-control px-2 pb-3"
        :class="{ 'has-error': errors.has('addressLong') }"
      >
        <span>{{ $t('longitude') }} </span>
        <v-text-field
          v-model="input.address_long"
          flat
          outline
          solo
          :placeholder="$t('longitude')"
          name="addressLong"
          class="default-input-textfield"
          :data-vv-as="$t('longitude')"
          hide-details
          disabled
        ></v-text-field>
        <p v-if="errors.has('addressLong')" class="text-error pt-2">
          {{ errors.first('addressLong') }}
        </p>
      </v-flex>
      <v-flex xs12 class="form-control px-2 pb-3" :class="{ 'has-error': errors.has('fileUrl') }">
        <span>{{ $t('upload_file') }} </span>

        <uploadalltype
          v-model="input.file_url"
          :multiple="true"
          @onUploaded="onUploadedFile($event)"
        ></uploadalltype>

        <div v-if="tempUploadFile && tempUploadFile.length > 0">
          <div class="py-3">ไฟล์ที่อัปโหลด</div>
          <v-list>
            <v-list-tile v-for="(item, index) in tempUploadFile" :key="index" avatar>
              <v-list-tile-avatar>
                <v-icon>folder</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <a :href="item" target="_blank">{{ getFileName(item) }}</a>
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="error" @click="handleRemoveFile(item)">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>

        <span v-show="errors.has('fileUrl')" class="text-error">
          {{ errors.first('fileUrl') }}
        </span>
      </v-flex>
      <v-flex xs12 class="pt-3 text-xs-center">
        <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="handleSaveData">{{ $t('Save') }}</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import uploadalltype from '@/components/elements/uploadalltype'
import { Validator } from 'vee-validate'

Validator.extend('isUserPhone', (value) => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value) && value.length == 10 ? true : false
})

export default {
  components: {
    uploadalltype
  },
  props: ['value'],
  data() {
    return {
      input: {
        full_name: '',
        email: '',
        phone_number: '',
        customer_type: '',
        pledge_water_tank: '',
        total_pledge_water_tank: '',
        store_type: '',
        branch_id: '',
        file_url: '',
        address_lat: '',
        address_long: ''
      },
      pledgeWaterTankOptions: [
        { label: 'มี', value: true },
        { label: 'ไม่มี', value: false }
      ],
      tempUploadFile: []
    }
  },
  computed: {
    tremendousMasterData() {
      return this.$store.state.tremendousMasterData
    },
    branchOptions() {
      return (
        this.tremendousMasterData.branch.map((el) => {
          return { name: el.branch_name, id: el.id }
        }) || []
      )
    }
  },
  mounted() {
    if (this.value) {
      this.input = this.value

      if (this.value && this.value.file_url) {
        this.tempUploadFile = JSON.parse(this.value.file_url)
      }
    }
  },

  methods: {
    async handleSaveData() {
      const vm = this
      try {
        let result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        vm.input.file_url = JSON.stringify(vm.tempUploadFile)

        vm.$emit('onSave', vm.input)
      } catch (error) {
        console.error(error)
      }
    },
    handleCancel() {
      this.$router.push({ name: 'customer' })
    },
    handleRemoveFile(item) {
      const tempAllUploadFile = this.tempUploadFile
      const index = tempAllUploadFile.indexOf(item)
      if (index > -1) {
        tempAllUploadFile.splice(index, 1)
      }
      this.tempUploadFile = tempAllUploadFile
    },
    getFileName(item) {
      const tempItem = item.split('/')
      const lastSegment = tempItem.pop() || tempItem.pop()
      const name = lastSegment.substring(13)

      return name ? name : '-'
    },
    onUploadedFile(url) {
      this.tempUploadFile = url
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/CustomerManage.vue